import script from "./menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./menu.vue?vue&type=script&lang=ts&setup=true"

import "./menu.vue?vue&type=style&index=0&id=5eb442bf&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb442bf"]])

export default __exports__